// src/utils/onboarding.js
// Shared onboarding constants — single source of truth for step routing.
// Used by OnboardingBanner, Onboarding.jsx (steps 5–6), and Dashboard SetupCard.

export const ONBOARDING_STEP_ROUTES = {
  // Hard gates — all handled within the /onboarding wizard
  baa:                '/onboarding',
  business_info:      '/onboarding',
  payment:            '/onboarding',
  phone_choice:       '/onboarding',
  twilio_setup:       '/onboarding',
  book_of_business:   '/onboarding',
  // Soft gates — handled in dedicated pages
  import_clients:     '/clients/import',
  review_automations: '/automations',
};
